import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MoveDown: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M8 18L12 22L16 18' }],
    ['path', { d: 'M12 2V22' }],
  ],
];

export default MoveDown;
